import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auctions-one-section',
  templateUrl: './auctions-one-section.component.html',
  styleUrls: ['./auctions-one-section.component.scss']
})
export class AuctionsOneSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
